import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-page-header',
  standalone: true,
  templateUrl: './ui-page-header.component.html',
  styleUrl: './ui-page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPageHeaderComponent {
  readonly actionsAriaLabel = input('Page actions');
}
